// @flow
import type { Errors } from 'types/errors';
import type { RequestStates } from 'types/redux';

import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';

import withEscapeToDismiss from 'components/others/WithEscapeToDismiss';
import ErrorNotification from 'components/others/ErrorNotification';

type Props = {
  driverBookingDropOff: Function,
  driverBookingDropOffRequest: RequestStates,
  driverBookingDropOffErrors: Errors,

  driverID: string,
  bookingID: string,

  handleClose: Function,
  showModal: boolean,

  resetErrorState: Function,
};

type State = {
  fare: number,
  bookingFee: number,
  otherFees: number,
};

@withEscapeToDismiss()
export default class DriverFareModal extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      fare: 10,
      bookingFee: 5,
      otherFees: 0,
    };
  }

  state: State;

  componentDidMount() {
    this.props.resetErrorState('driverBookingDropOff');
  }

  props: Props;

  render() {
    return (
      <div
        className={classnames('modal', {
          'is-active': this.props.showModal,
        })}
        role="dialog"
      >
        <div
          className="modal-background" onClick={() => {
            this.props.handleClose();
          }}
        />
        <div className="modal-content">
          <div className="modal-box">
            <button
              aria-label="Close modal"
              className="is-pulled-right delete"
              onClick={() => {
                this.props.handleClose();
              }}
            />
            <h3 className="title is-5">{this.props.bookingID}</h3>
            <hr />
            <form
              onSubmit={(event) => {
                event.preventDefault();
                this.props.driverBookingDropOff(this.props.driverID, this.props.bookingID,
                parseFloat(this.state.fare), parseFloat(this.state.bookingFee),
                parseFloat(this.state.otherFees));
              }}
            >
              <div className="columns">
                <div className="column is-3">
                  <label className="label" htmlFor="taxi-type-id">Fare</label>
                  <input
                    className="input"
                    name="fare"
                    value={this.state.fare}
                    onChange={(event) => {
                      this.setState({
                        fare: event.target.value,
                      });
                    }}
                  />
                </div>
                <div className="column is-3">
                  <label className="label" htmlFor="taxi-type-id">Booking Fee</label>
                  <input
                    className="input"
                    name="booking-fee"
                    value={this.state.bookingFee}
                    onChange={(event) => {
                      this.setState({
                        bookingFee: event.target.value,
                      });
                    }}
                  />
                </div>
                <div className="column is-3">
                  <label className="label" htmlFor="taxi-type-id">Other Fees</label>
                  <input
                    className="input"
                    name="other-fees"
                    value={this.state.otherFees}
                    onChange={(event) => {
                      this.setState({
                        otherFees: event.target.value,
                      });
                    }}
                  />
                </div>
                <div className="column is-3">
                  <label className="label" htmlFor>&nbsp;</label>
                  <div className="control is-grouped">
                    <p className="control">
                      <button
                        type="submit" className={classnames('button is-info', {
                          'is-loading': this.props.driverBookingDropOffRequest.isPending,
                          'is-disabled': this.props.driverBookingDropOffRequest.isPending,
                        })}
                      >
                        Submit
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </form>
            <br />
            {!_.isEmpty(this.props.driverBookingDropOffErrors) &&
              <ErrorNotification errors={this.props.driverBookingDropOffErrors} />
            }
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/drivers/DriverFareModal.jsx
 **/